import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody, CardTitle } from 'reactstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';

import "../styles/dataTable.css"
import searchIcon from '../assets/images/search_icon.svg'
import addIcon from '../assets/images/add-icon.svg'
import arrowIcon from '../assets/images/Arrow.svg'
import upwardArrowIcon from '../assets/images/upward_arrow.svg'
import editIcon from '../assets/images/edit_icon.svg'
import CreatePackageInPage from './CreatePackageInPage';
import gsap from 'gsap';
import UpdatePackageInPage from './UpdatePackageInPage';

const ManagePackage = () => {
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);
  const vendor = JSON.parse(localStorage.getItem("vendor"));

  const packageLimit = Number(vendor?.package_limit || 1);
  const [categories, setCategories] = useState([]);
  const [packageCount, setPackageCount] = useState([]);

  const [showCreatePackage, setShowCreatePackage] = useState(false);
  const [showUpdatePackage, setShowUpdatePackage] = useState(false);
  const containerRef = useRef(null)
  const containerUpdateRef = useRef(null)

  const [cardId, setCardId] = useState(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  // Table
    const [search, setSearch] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");
  
    const filteredData = cards.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  
    if (sortField) {
      filteredData.sort((a, b) => {
        const valA = a[sortField];
        const valB = b[sortField];
        if (typeof valA === "number") {
          return sortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          return sortOrder === "asc"
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
        }
      });
    }
  
    const totalPages = Math.ceil(filteredData.length / entriesPerPage);
    const paginatedData = filteredData.slice(
      (currentPage - 1) * entriesPerPage,
      currentPage * entriesPerPage
    );
  
    useEffect(() => {
      if (currentPage > totalPages) setCurrentPage(1);
    }, [search, entriesPerPage, totalPages]);
  
    // Sort Toggle Handler
    const handleSort = (field) => {
      if (sortField === field) {
        setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
      } else {
        setSortField(field);
        setSortOrder("asc");
      }
    };


  useEffect(() => {
    fetchCategory();
    fetchCards();
    fetchPackageCount();
  }, [showCreatePackage, showUpdatePackage]);

  useEffect(() => {
    if (cards.length) {
      $('#packageTable').DataTable();
    }
  }, [cards]);


  const fetchCategory = async () => {
    try {
      const response = await api.get('/page/get-all');
      setCategories(response.data.data);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchPackageCount = async () => {
    try {
      const response = await api.get(`/api/Vendorlist/packageLimit/${vendor.id}`);
      setPackageCount(response.data.data);
      console.log(response.data.data);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchCards = async () => {
    try {
      const response = await api.get(`/vendor/productlist/${vendor.id}`);
      setCards(response.data.data);
    } catch (error) {
      console.error('Error fetching card data:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/cards/${id}`);
      setCards(cards.filter(card => card.id !== id));
      alert(`Package with ID ${id} deleted successfully`);
    } catch (error) {
      console.error('Error deleting package:', error);
      alert('Error deleting package');
    }
  };

  


  function handlePackageUpdate(id){
    setCardId(id)
    setShowUpdatePackage(true)
  }

  const handleCreatePackageClick = () => {
    if (packageCount?.allowed_packages <= packageCount?.current_packages) {
      setShowUpgradeModal(true);
      return;
    }

    setShowCreatePackage(true);
  };

  return (
    
    <div style={{position: 'relative', height: showCreatePackage || showUpdatePackage ? "100vh" : 'auto', overflow : 'hidden' }}>

      <div style={{ padding: "20px", opacity: showCreatePackage || showUpdatePackage ? 0 : 1 }}>
        {/* Table Header */}
        <div className="table-header">
              <h2 style={{fontWeight: 700,}}>Package List</h2>

              <div className="search-container">
                  <input
                  type="text"
                  value={search}
                  onChange={(e) => {
                      setSearch(e.target.value);
                      setCurrentPage(1);
                  }}
                  placeholder="search"
                  />
                  <img src={searchIcon} alt="search-icon" className="search-icon" />
              </div>

              <div className="entries-container">
                  <label htmlFor="noOfEntries">Show: </label>
                  <select
                      value={entriesPerPage}
                      id="noOfEntries"
                      onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                  >
                      <option value={10}>10 Entries per page </option>
                      <option value={50}>50 Entries per page</option>
                      <option value={100}>100 Entries per page</option>
                  </select>
              
              </div>

              <div className="action-btn">
                  <button onClick={handleCreatePackageClick}>
                    <img src={addIcon} alt="add-icon" />  Add Package
                  </button>
              </div>

          </div>

            {/* Table */}
        <table width="100%" cellPadding="26" className="table-no-outer-border">
          <thead>
            <tr>
              
              <th onClick={() => handleSort("category_id")}>
                <div className='name-container'>
                  Pilgrimage Type
                  <div className='sort-arrow-container'>
                    <img src={upwardArrowIcon} alt="upward-arrow"
                      style={ {opacity: sortField === "category_id" ? (sortOrder === "asc" ? 1 : 0.5) : 0.5 }}
                    />
                    <img src={upwardArrowIcon} alt="upward-arrow" style={{transform: 'rotateX(180deg)', marginTop: "5px",
                      opacity: sortField === "category_id" ? (sortOrder === "asc" ? 0.5 : 1) : 0.5
                    }} />
                  </div>
                </div>
              </th>
      
              <th onClick={() => handleSort("duration")}>
                <div className='name-container'>
                  Duration 
                  <div className='sort-arrow-container'>
                    <img src={upwardArrowIcon} alt="upward-arrow"
                      style={ {opacity: sortField === "duration" ? (sortOrder === "asc" ? 1 : 0.5) : 0.5 }}
                    />
                    <img src={upwardArrowIcon} alt="upward-arrow" style={{transform: 'rotateX(180deg)', marginTop: "5px",
                      opacity: sortField === "duration" ? (sortOrder === "asc" ? 0.5 : 1) : 0.5
                    }} />
                  </div>
                </div>
              </th>
              <th onClick={() => handleSort("price")}>
                <div className='name-container'>
                  Price 
                  <div className='sort-arrow-container'>
                    <img src={upwardArrowIcon} alt="upward-arrow"
                      style={ {opacity: sortField === "price" ? (sortOrder === "asc" ? 1 : 0.5) : 0.5 }}
                    />
                    <img src={upwardArrowIcon} alt="upward-arrow" style={{transform: 'rotateX(180deg)', marginTop: "5px",
                      opacity: sortField === "price" ? (sortOrder === "asc" ? 0.5 : 1) : 0.5
                    }} />
                  </div>
                </div>
              </th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((card, i) => {
                const srNo = (currentPage - 1) * entriesPerPage + i + 1;
                return(
                  <tr key={card.id}>
                    {/* <td>{srNo}</td> */}
                    <td>{categories?.filter(el => el.id === card.category_id)[0]?.name}</td>
                    {/* <td>{card.city}</td> */}
                    <td>{card.duration}</td>
                    <td>₹ {parseFloat(card.price).toLocaleString('en-IN')}</td>
                    <td>{card?.is_approved !== '1' ? "Pending" : "Approved"}</td>
                    
                    <td className='text-center align-middle'>
                      {/* <FaEdit style={{ cursor: 'pointer', color: '#24297B', fontSize: '21px' }} onClick={() => navigate(`/update-vendor/${row.id}`)} /> */}
                        {/* <FaTrash style={{ cursor: 'pointer', color: 'red' }} onClick={() => handleDelete(vendor.id)} /> */}

                        <button className='edit-button' onClick={() => handlePackageUpdate(card.id)}>
                          <img src={editIcon} alt="editIcon" />
                          Edit
                        </button>
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={9} style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div>

        </div>
          <div style={{paddingBottom: '30px', background: '#fff'}}>
            <div style={{ padding: "30px", textAlign: "center", borderTop: '2px solid #F2F2F2',borderBottom: '2px solid #F2F2F2'}}>
              {/* Prev arrow */}
              <button
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  style={{
                  margin: "0 5px",
                  padding: "5px 10px",
                  background: "#fff",
                  border: "none",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  color: currentPage === 1 ? "#ccc" : "#000"
                  }}
              >
                <img src={arrowIcon} alt="arrow-icon"
                  style={{
                    opacity: currentPage === 1 ? "0.5" : "1",
                  }}
                />

              </button>

              {/* Page Numbers */}
              {(() => {
                  const pageButtons = [];
                  const maxVisiblePages = 4;

                  if (totalPages <= maxVisiblePages + 1) {
                  // Show all pages if total pages is small
                  for (let i = 1; i <= totalPages; i++) {
                      pageButtons.push(i);
                  }
                  } else {
                  if (currentPage <= maxVisiblePages) {
                      // Show first 4 pages and last
                      for (let i = 1; i <= maxVisiblePages; i++) {
                      pageButtons.push(i);
                      }
                      pageButtons.push('...', totalPages);
                  } else if (currentPage > totalPages - maxVisiblePages) {
                      // Show first, ..., last 4 pages
                      pageButtons.push(1, '...');
                      for (let i = totalPages - maxVisiblePages + 1; i <= totalPages; i++) {
                      pageButtons.push(i);
                      }
                  } else {
                      // Middle section: 1, ..., current-1, current, current+1, ..., last
                      pageButtons.push(1, '...');
                      pageButtons.push(currentPage - 1, currentPage, currentPage + 1);
                      pageButtons.push('...', totalPages);
                  }
                  }

                  return pageButtons.map((page, index) => {
                  if (page === '...') {
                      return (
                      <span key={`ellipsis-${index}`} style={{ margin: "0 5px" }}>...</span>
                      );
                  }

                  return (
                      <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      style={{
                          margin: "0 5px",
                          padding: "5px 10px",
                          background: currentPage === page ? "#D9D9D9" : "#fff",
                          color: currentPage === page ? "black" : "#00000075",
                          border: "none",
                          cursor: "pointer",
                      }}
                      >
                      {page}
                      </button>
                  );
                  });
              })()}

              {/* Next arrow */}
              <button
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  style={{
                  margin: "0 5px",
                  padding: "5px 10px",
                  background: "#fff",
                  border: "none",
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  color: currentPage === totalPages ? "#ccc" : "#000"
                  }}
              >
                  <img src={arrowIcon} alt="arrow-icon"
                    style={{
                      opacity: currentPage === totalPages ? "0.5" : "1",
                      transform: 'rotateY(180deg)'
                    }}
                  />
              </button>
            </div>
          </div>

      </div>

        {
          showCreatePackage &&
          <CreatePackageInPage setShowCreatePackage={setShowCreatePackage} containerRef={containerRef} />
        }

        {
          showUpdatePackage &&
          <UpdatePackageInPage setShowUpdatePackage={setShowUpdatePackage} containerUpdateRef={containerUpdateRef} id={cardId} />
        }

        {
          showUpgradeModal && (
            <div
              style={styles.modalOverlay}
              onClick={() => setShowUpgradeModal(false)}
            >
              <div
                style={styles.modalCard}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  style={styles.closeBtn}
                  onClick={() => setShowUpgradeModal(false)}
                >
                  ✕
                </button>

                <div style={styles.badge}>
                  Package Limit Reached
                </div>

                <h3 style={styles.title}>
                  Upgrade Your Plan
                </h3>

                <p style={styles.description}>
                  You can only add{" "}
                  <strong>{packageCount?.allowed_packages}</strong>{" "}
                  {packageCount?.allowed_packages === 1 ? "package" : "packages"} with your current
                  plan. Please upgrade your plan to add more packages.
                </p>

                <button
                  type="button"
                  style={styles.upgradeButton}
                  onClick={() => {
                    setShowUpgradeModal(false);
                    navigate("/upgrade");
                  }}
                >
                  Upgrade Now
                </button>

                <p style={styles.subText}>
                  Upgrade your plan to unlock more package listings.
                </p>
              </div>
            </div>
          )
        }

    </div>
  );
};

export default ManagePackage;


const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(18, 48, 38, 0.65)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "20px",
  },

  modalCard: {
    backgroundColor: "#FAF6EF",
    border: "1px solid #D1C5B4",
    borderRadius: "16px",
    padding: "36px 28px 28px 28px",
    width: "100%",
    maxWidth: "500px",
    textAlign: "center",
    position: "relative",
    boxShadow: "0 15px 35px rgba(0, 0, 0, 0.2)",
    fontFamily: "inherit",
  },

  closeBtn: {
    position: "absolute",
    top: "16px",
    right: "18px",
    background: "none",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
    color: "#888888",
    padding: "4px",
    lineHeight: "1",
  },

  badge: {
    display: "inline-block",
    backgroundColor: "#0B4234",
    color: "#FFFFFF",
    padding: "4px 16px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: "600",
    textTransform: "capitalize",
    marginBottom: "16px",
  },

  title: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#222222",
    marginBottom: "12px",
    marginTop: "0px",
  },

  description: {
    fontSize: "15px",
    color: "#555555",
    lineHeight: "1.5",
    marginBottom: "24px",
  },

  upgradeButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    backgroundColor: "#C36E2B",
    color: "#FFFFFF",
    padding: "14px 20px",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    textDecoration: "none",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(195, 110, 43, 0.3)",
    transition: "all 0.2s ease-in-out",
  },

  subText: {
    fontSize: "12px",
    color: "#888888",
    marginTop: "16px",
    marginBottom: "0px",
  },
};